import { render, staticRenderFns } from "./AtestoProcessos.vue?vue&type=template&id=b193aa68"
import script from "./AtestoProcessos.vue?vue&type=script&lang=js"
export * from "./AtestoProcessos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports